import React from 'react';
import { Spin } from 'antd';
import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppLayout } from 'container/layouts/AppLayout';
import { AuthRoutes, MainRoutes, PublicRoutes } from './Routes';
import AuthLayout from 'container/layouts/AuthLayout';
import { CommonDataProvider } from 'contexts/CommonDataContext/CommonDataProvider';
import { LocalStorageKeys, useLocalStorage } from 'hooks/useLocalStorage';

export const AppRouter = () => {
  const [user] = useLocalStorage(LocalStorageKeys.user, null, false);

  if (
    !user &&
    !AuthRoutes.map(x => x.path).includes(window.location.pathname) &&
    !PublicRoutes.map(x => x.path).includes(window.location.pathname)
  ) {
    window.location.href = '/login';
  }

  if (user?.shouldShowOnboarding && !window.location.href.includes('/set-new-password')) {
    window.location.href = '/set-new-password';
  }

  return (
    <BrowserRouter basename={(process as any).env.PUBLIC_URL}>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Routes>
          {PublicRoutes.map((route, index) => (
            <Route key={`public-${index}`} {...route} />
          ))}

          {/* Auth routes */}
          <Route element={<AuthLayout />}>
            {AuthRoutes.map((route, index) => (
              <Route key={`auth-${index}`} {...route} />
            ))}
          </Route>

          {/* Protected routes */}
          <Route
            element={
              <CommonDataProvider>
                <AppLayout />
              </CommonDataProvider>
            }
          >
            {MainRoutes.map((route, index) => (
              <Route key={`main-${index}`} {...route} />
            ))}
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
